import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { EntitySelectModule } from '../../common-components/entity-select/entity-select.module';
import { MergeDepartmentComponent } from './merge-department.component';

@NgModule({
   declarations: [MergeDepartmentComponent],
   imports: [
      CommonModule,
      MatButtonModule,
      MatDialogModule,
      MatFormFieldModule,
      MatIconModule,
      MatInputModule,
      MatInputModule,
      ReactiveFormsModule,
      EntitySelectModule,
   ],
})
export class MergeDepartmentModule {}
